<template>
  <div v-cloak>
    <v-breadcrumbs
      v-cloak
      id="article-breadcrumbs"
      class="breadcrumbs-container"
      :items="items"
      divider=">"
    >
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          exact
          :href="item.Link"
          class="breadcrumb-item display-16"
        >{{ item.KeyValue.Value }}</v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
[v-cloak] .v-breadcrumbs.breadcrumbs-container {
  display: none;
}
.v-breadcrumbs.breadcrumbs-container li.breadcrumb-item a {
  color: black;
}

// .breadcrumbs-container {
//   padding-top: 0;
//   padding-bottom: 0;
// }
.breadcrumbs-container
  li.breadcrumb-item
  a.v-breadcrumbs__item.v-breadcrumbs__item--disabled {
  color: $primary;
  font-weight: 400;
}

.breadcrumbs-container .v-breadcrumbs__divider {
  padding: 0 6px !important;
}

#article-breadcrumbs li:last-child {
  color: black;
  font-weight: 400;
  cursor: pointer;
  pointer-events: none;
}
</style>
